import { Check, X, Inbox } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Panel, Empty } from "@/components/common";
import { UserAvatar } from "@/components/UserAvatar";
import { api, errMsg, fmtDateTime } from "@/lib/api";

function Row({ c, children }) {
  return (
    <li className="flex flex-wrap items-center gap-3 px-5 py-3" data-testid={`netsoci-request-${c.id}`}>
      <UserAvatar name={c.name} />
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium">{c.name}</span>
        <span className="block truncate text-xs text-muted-foreground">{c.company} · {fmtDateTime(c.since)}</span>
      </span>
      {children}
    </li>
  );
}

export function ConnRequests({ conns, onChange }) {
  const act = async (fn, msg) => { try { await fn(); toast.success(msg); onChange(); } catch (e) { toast.error(errMsg(e)); } };
  const { incoming, outgoing, blocked } = conns;
  if (!incoming.length && !outgoing.length && !blocked.length) return <Empty icon={Inbox} text="Nessuna richiesta in sospeso." testId="netsoci-requests-empty" />;
  return (
    <div className="space-y-6">
      {incoming.length > 0 && (
        <Panel title="Ricevute" testId="netsoci-incoming">
          <ul className="divide-y">
            {incoming.map((c) => (
              <Row key={c.id} c={c}>
                <Button size="sm" onClick={() => act(() => api.post(`/network/connections/${c.connection_id}/respond`, { accept: true }), "Collegamento accettato")} data-testid={`netsoci-request-accept-${c.id}`}><Check className="mr-1.5 h-4 w-4" />Accetta</Button>
                <Button size="sm" variant="outline" onClick={() => act(() => api.post(`/network/connections/${c.connection_id}/respond`, { accept: false }), "Richiesta rifiutata")} data-testid={`netsoci-request-reject-${c.id}`}><X className="mr-1.5 h-4 w-4" />Rifiuta</Button>
              </Row>
            ))}
          </ul>
        </Panel>
      )}
      {outgoing.length > 0 && (
        <Panel title="Inviate" testId="netsoci-outgoing">
          <ul className="divide-y">
            {outgoing.map((c) => (
              <Row key={c.id} c={c}>
                <Button size="sm" variant="ghost" onClick={() => act(() => api.delete(`/network/connections/${c.connection_id}`), "Richiesta ritirata")} data-testid={`netsoci-request-withdraw-${c.id}`}>Ritira</Button>
              </Row>
            ))}
          </ul>
        </Panel>
      )}
      {blocked.length > 0 && (
        <Panel title="Bloccati" testId="netsoci-blocked">
          <ul className="divide-y">
            {blocked.map((c) => (
              <li key={c.id} className="flex items-center gap-3 px-5 py-3 text-sm">
                <span className="flex-1 font-medium">{c.name}<span className="block text-xs font-normal text-muted-foreground">{c.company}</span></span>
                <Button size="sm" variant="outline" onClick={() => act(() => api.delete(`/network/block/${c.id}`), "Contatto sbloccato")} data-testid={`netsoci-unblock-${c.id}`}>Sblocca</Button>
              </li>
            ))}
          </ul>
        </Panel>
      )}
    </div>
  );
}
